import { Layout } from 'antd';
import NavBar from "../../components/NavBar";
import TaskDetail from "../../components/task/TaskDetail";

const { Content } = Layout;

function TaskMag({ match }) {
   return (
      <Layout className="container main-layout">
         <NavBar />
         <Layout className="bg-gray">
            <Content className="layout-content">
               <TaskDetail/>
            </Content>
         </Layout>
      </Layout>
   );
}

export default TaskMag;
